// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Jm-z","tupacHeader":"Km-z","tupacHeader2":"Lm-z","tupacMenu":"Mm-z","tupacMenu2":"Nm-z","tupacMain":"Om-z","tupacMain2":"Pm-z"};